var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddnewcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 0.799988C2.41766 0.799988 0 3.21765 0 6.19999V20.6C0 23.5823 2.41766 26 5.4 26H5.5276C5.44351 25.4121 5.4 24.8111 5.4 24.2C5.4 17.2412 11.0412 11.6 18 11.6C24.9588 11.6 30.6 17.2412 30.6 24.2C30.6 24.8111 30.5565 25.4121 30.4724 26H30.6C33.5823 26 36 23.5823 36 20.6V6.19999C36 3.21765 33.5823 0.799988 30.6 0.799988H5.4Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 33.2C22.9706 33.2 27 29.1705 27 24.2C27 19.2294 22.9706 15.2 18 15.2C13.0294 15.2 9 19.2294 9 24.2C9 29.1705 13.0294 33.2 18 33.2ZM18 18.8C18.9941 18.8 19.8 19.6059 19.8 20.6V22.4H21.6C22.5941 22.4 23.4 23.2059 23.4 24.2C23.4 25.1941 22.5941 26 21.6 26H19.8V27.8C19.8 28.7941 18.9941 29.6 18 29.6C17.0059 29.6 16.2 28.7941 16.2 27.8L16.2 26H14.4C13.4059 26 12.6 25.1941 12.6 24.2C12.6 23.2059 13.4059 22.4 14.4 22.4H16.2V20.6C16.2 19.6059 17.0059 18.8 18 18.8Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddnewcard);
export default __webpack_public_path__ + "static/media/addnewcard.6e8a510f110060be95ff37957c7387d5.svg";
export { ForwardRef as ReactComponent };